<template>
  <div>
    <div class="search flex">
      <span class="tit">用户管理</span>
      <div class="flex">
          <el-radio-group
            v-model="userCondition.accountState"
            size="small"
            @change="getData" class="radioGroup">
          <el-radio-button label="2">所有</el-radio-button>
          <el-radio-button label="1">正常</el-radio-button>
          <el-radio-button label="0">封禁</el-radio-button>
        </el-radio-group>
        <el-button @click="toEvent" size="mini" class="addBtn">操作日志</el-button>
        <el-input placeholder="请输入名称/手机号/邮箱" class="addART" v-model="search" suffix-icon="el-icon-search"
                  size="small"
                  @change="handleCurrentChange(1)"></el-input>
      </div>
    </div>
    <div class="instrument">
      <el-table
          :data="userList"
          class="record-table"
          :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
          height="calc(100vh - 292px)"
          style="width: 100%;font-size:14px;color:#333;font-weight:400;margin-bottom: 10px;"
          max-height="calc(100vh - 292px)">
        <el-table-column
            align="center"
            prop="fullName"
            label="名称"
            width="100" show-overflow-tooltip>
        </el-table-column>
        <el-table-column width="80" label="头像" align="center">
          <template slot-scope="scope">
            <el-image
                style="width: 60px;height: 60px"
                :src="scope.row.headImgPath" fit="cover">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            width="60"
            prop="gender"
            label="性别">
          <template slot-scope="scope">
            <span>{{ scope.row.gender === 1 ? '男' : scope.row.gender === 0 ? '女' : '-' }}</span>
            <!-- <el-tag v-if="scope.row.gender === 1" effect="plain">男</el-tag>
             <el-tag v-if="scope.row.gender === 2" type="danger" effect="plain">女</el-tag>-->
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            width="100"
            prop="accountState"
            label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.accountState === 0" class="pink common"
                  @click="changeStatus(scope.row.id,scope.row.accountState)">封禁</span>
            <span v-else class="green common" @click="changeStatus(scope.row)">正常</span>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            width="50"
            prop="age"
            label="年龄">
        </el-table-column>
        <el-table-column
            prop="mobile" align="center"
            width="125"
            label="手机">
        </el-table-column>
        <el-table-column
            prop="email" align="center"
            width="200"
            label="邮箱">
        </el-table-column>
        <el-table-column
            align="center"
            prop="workJob"
            label="工作"
            show-overflow-tooltip>
        </el-table-column>
        <el-table-column
            prop="abodeCity"
            label="城市"
            align="center"
            show-overflow-tooltip>
        </el-table-column>
        <el-table-column
            prop="createDate"
            label="注册时间" min-width="150"
            align="center"
            show-overflow-tooltip>
        </el-table-column>
        <el-table-column
            align="right" fixed="right"
            width="220">
          <template slot-scope="scope">
            <el-button size="mini" type="text" class="btn" @click="updateRemark(scope.row)">备注</el-button>
            <!--<el-button v-if="scope.row.accountState === 0" size="mini" type="text" class="btn"-->
            <!--           @click="changeStatus(scope.row.id,scope.row.accountState)">启用-->
            <!--</el-button>-->
            <!--<el-button v-else size="mini" type="text" class="btn"-->
            <!--           @click="changeStatus(scope.row.id,scope.row.accountState)">禁用-->
            <!--</el-button>-->
            <el-button size="mini" type="text" class="btn" @click="reset(scope.row.id)">重置密码</el-button>
            <el-button @click="toDetail(scope.row.id)" class="btn" type="text" size="mini">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          :hide-on-single-page="true"
          class="pagination"
          background
          prev-text="Prev"
          next-text="Next"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.current"
          :page-size="page.size"
          layout="prev, pager, next"
          :total="page.total">
      </el-pagination>
    </div>
    <!--    重置密码-->
    <el-drawer title="重置密码" :visible.sync="dialogFormVisible" :wrapperClosable="false"
               :show-close="false" size="600px" class="drawerCommon">
      <el-form :model="resetPasswordData" ref="ruleForm" :rules="rules" label-suffix="：" label-width="100px"
               class="maxHeight">

        <el-form-item label="新密码" prop="remark">
          <el-input type="password" v-model="resetPasswordData.remark" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input type="password" v-model="checkPass" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="原因">
          <el-input v-model="resetPasswordData.reason" type="textarea" :rows="5" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="toResetPassword('ruleForm')">确 定</el-button>
      </div>
    </el-drawer>

  </div>
</template>

<script>
import commonjs from "../../../api/common";

export default {
  name: "userList",
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass');
        }
        callback();
      }
    };
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (this.checkPass !== this.resetPasswordData.remark) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      userList: [],//用户数据
      search: '',//搜索
      page: {
        current: 1,
        size: 8,
        total: 8
      },//分页
      userCondition: {
        fullName: '',
        mobile: '',
        email: '',
        accountState: 2,
      },//查询条件
      remark: {
        remark: '',
      },//备注
      banCondition: {
        eventId: '',//userId
        reason: '',//原因
      },//封禁解封原因数据

      resetPasswordData: {
        eventId: '',
        reason: '',
        remark: '',
      },
      checkPass: '',

      dialogFormVisible: false,
      formLabelWidth: false,

      rules: {
        remark: [
          {validator: validatePass, trigger: 'blur'},
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 6, max: 20, message: '密码要求6-20位', trigger: 'blur'}
        ],
        checkPass: [
          {validator: validatePass2, trigger: 'blur'}
        ],
      }
    }
  },
  mounted() {
    this.getData();//获得数据
  },
  methods: {
    //获得数据
    getData() {
      this.userCondition.fullName = this.search;
      this.userCondition.mobile = this.search;
      this.userCondition.email = this.search;
      let that = this;
      this.$ajax
          .post(commonjs.api.user.admin.page.replace("{current}/{size}", this.page.current + "/" + this.page.size), this.userCondition)
          .then(function (res) {
            if (res.data.status === 'success') {
              that.userList = res.data.rows;
              that.page.total = res.data.total;
            }
          })
    },
    // 每页多少条
    handleSizeChange(val) {
      this.page.size = val;
    },
    // 当前页  根据标签页分别执行传输
    handleCurrentChange(val) {
      this.page.current = val;
      this.getData();
    },
    //改变状态
    changeStatus(item) {
      let that = this;
      let msg;
      if (item.accountState === 0) {
        msg = '启用'
      } else {
        msg = '禁用'
      }
      this.$prompt('请输入原因', msg, {
        confirmButtonText: '提交',
        cancelButtonText: '取消',
      }).then(({value}) => {
        this.banCondition.eventId = item.id;
        this.banCondition.reason = value;
        this.$ajax
            .post(commonjs.api.user.admin.status.replace("{status}", (item.accountState + 1) % 2), this.banCondition)
            .then(function (res) {
              if (res.data.status === 'success') {
                that.$message.success('操作成功');
                item.accountState = (item.accountState + 1) % 2;
              } else {
                that.$message.error(res.data.message);
              }
            })
      }).catch(() => {
        this.$message.info('取消');
      })
    },
    reset(id) {
      this.dialogFormVisible = true;
      this.resetPasswordData.eventId = id;
    },
    //重置密码
    toResetPassword(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$ajax
              .post(commonjs.api.user.admin.password, this.resetPasswordData)
              .then(function (res) {
                if (res.data.status === 'success') {
                  that.$message.success('操作成功');
                  that.resetPasswordData = {};
                  that.dialogFormVisible = false;
                } else {
                  that.$message.error(res.data.message);
                }
              })
        } else {
          this.$message.error("请检查输入");
          return false;
        }
      });


    },
    //备注
    updateRemark(item) {
      let that = this;
      this.$prompt('请填写备注', '备注', {
        confirmButtonText: '提交',
        cancelButtonText: '取消',
        inputValue: item.remark,
      }).then(({value}) => {
        this.remark.remark = value;
        this.$ajax
            .post(commonjs.api.user.admin.remark.replace("{userId}", item.id), this.remark)
            .then(function (res) {
              if (res.data.status === 'success') {
                that.$message.success('操作成功');
                item.remark = value;
              } else {
                that.$message.error(res.data.message);
              }
            })
      }).catch(() => {
        this.$message.info('取消备注');
      })
    },
    toDetail(id) {
      this.$router.push({path: 'detail/' + id})
    },
    toEvent() {
      this.$router.push({path: '../event/list'})
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../assets/css/admin.scss';

.search .radioGroup {
  margin-right: 10px;
}
</style>